import 'animate.css/animate.css'
import React from 'react'
import handleViewport from 'react-in-viewport'

class Animation_Container extends React.Component {

      constructor(props) {
          super(props)
          this.state = {
              inViewport: false,
              animation_complete: false,
              classChanged: false,
          }
      }

  componentDidMount() {
    // PageRevealer's own children use force=true, let them animate immediately
    if (this.props.force) {
      this.runAnimation();
      return;
    }

    // If page reveal already happened (e.g. HMR hot-reload), check viewport directly
    if (typeof window !== 'undefined' && window.__pageRevealed) {
      if (this.props.inViewport && !this.state.animation_complete) {
        this.runAnimation();
      }
      return;
    }

    // Wait for PageRevealer to finish before allowing animations
    if (typeof window !== 'undefined') {
      this._onPageRevealed = () => {
        // If currently in viewport, animate now
        if (this.props.inViewport && !this.state.animation_complete) {
          this.runAnimation();
        }
      };
      window.addEventListener('pageRevealed', this._onPageRevealed, { once: true });
    }
  }

  componentWillUnmount() {
    if (this._onPageRevealed && typeof window !== 'undefined') {
      window.removeEventListener('pageRevealed', this._onPageRevealed);
    }
  }

  runAnimation() {
    this.setState({ inViewport: true, animation_complete: true });
    this.changeClass();
  }

  componentDidUpdate() {
      // Always re-check the global flag directly (belt-and-suspenders)
      const pageReady = this.props.force || (typeof window !== 'undefined' && window.__pageRevealed);
      if (pageReady && !this.state.animation_complete && this.props.inViewport) {
          this.runAnimation();
      }
  }

      changeClass() {
        const { delay } = this.props
        setTimeout(() => { 
            this.setState({classChanged: true});
        }
        , delay);
      }

      render() {
        const { children, animation, id, height } = this.props
        const refProp = this.props.innerRef || this.props.forwardedRef || null;
        return (
            <div ref={refProp} className={this.state.classChanged ? `animated ${animation}` : ""} style={{opacity: this.state.classChanged ? 1 : 0, height: height ? height : "auto"}} id={id} >
                {children}
            </div>
        );
      }

}
const AnimationContainer = typeof handleViewport === 'function' 
  ? handleViewport(Animation_Container) 
  : Animation_Container;

export default AnimationContainer;